import z from 'zod'
import { LoggerContexts } from '../../app/utils/logger'

const severityLevels = z.enum(['debug', 'info', 'warn', 'error'])

const loggerSeverityConfigSchemaBase = z.object({
  contextSeverities: z.record(z.string(), z.any()).transform((record) => {
    // Filter out invalid properties and values to prevent parsing errors
    const validKeys = Object.keys(LoggerContexts)
    const filteredRecord: Record<string, string> = {}

    for (const [key, value] of Object.entries(record)) {
      if (validKeys.includes(key) && severityLevels.safeParse(value).success) {
        filteredRecord[key] = value
      }
    }

    return filteredRecord
  })
})

export const loggerSeverityConfigSchema = loggerSeverityConfigSchemaBase.default({
  contextSeverities: {
    OneSignal: 'debug',
    RootNavigator: 'debug',
    StoreProvider: 'debug',
    AppleCheckout: 'debug',
    AppVersionAlert: 'info',
    AudioService: 'error',
    Linking: 'error',
    NavigationUtilities: 'error',
    AdminNavigator: 'error',
    Game: 'error',
    GameEvents: 'error',
    LegacySubscriptionClient: 'error',
    Messages: 'error',
    SessionUser: 'error',
    SessionDaily: 'error',
    SubscriptionClient: 'error',
    Membership: 'error',
    ChannelStore: 'error',
    ChatStore: 'error',
    NetworkStore: 'error',
    PermissionsStore: 'error',
    ShareStore: 'error',
    RootStore: 'error',
    ZogoStore: 'error',
    MondayStore: 'error',
    LessonsStore: 'error',
    AppBase: 'error',
    CardAndActions: 'error',
    DrawerNavigator: 'error',
    GameModal: 'error',
    PlayerCell: 'error',
    DailyTask: 'error',
    ActiveGameScreen: 'error',
    CreateTournamentScreen: 'error',
    GameScreen: 'error',
    LobbyScreen: 'error',
    SignUpScreen: 'error',
    ZogoScreen: 'error',
    JoinPremiumScreen: 'error',
    ManageMembershipScreen: 'error'
  }
})
